import { DomainsApiConfig, DomainsPermissions } from '@wix/domains-serverless-interface';
const ANONYMOUS_DOMAINS_ACCOUNT = {
  hasValidVouchers: false,
  domainPermissions: [DomainsPermissions.AccountLevelPurchaseDomain],
  vouchers: [],
  coupons: [],
  unassignedDomains: [],
  assignedDomains: {},
  sites: [],
  domains: []
};
const ANONYMOUS_CAN_CHANGE_DOMAIN_OWNER = {
  canChangeOwner: false
};
export const ANONYMOUS_SETTLEMENTS = [{
  methodConfig: DomainsApiConfig.domainsAccount,
  data: ANONYMOUS_DOMAINS_ACCOUNT
}, {
  methodConfig: DomainsApiConfig.canChangeDomainOwner,
  data: ANONYMOUS_CAN_CHANGE_DOMAIN_OWNER
}];
//# sourceMappingURL=anonymousSettlements.js.map